import styled from 'styled-components';

import { Text } from '../../../../components';
import { COLORS, SPACE } from '../../../../theme/tokens';

export const Head = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[4]};
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[20]};
`;

export const Note = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
`;

/** The effective image: its thumbnail, size and source, then the actions. */
export const ImageRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACE[16]};
  flex-wrap: wrap;
`;

export const ImageThumb = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 152px;
  aspect-ratio: 1.91 / 1;
  border-radius: 8px;
  border: 1px solid ${COLORS.panelBorder};
  background: ${COLORS.surfaceInset};
  overflow: hidden;
  flex-shrink: 0;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ImageMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[4]};
  min-width: 0;
  flex: 1 1 160px;
`;

export const Dimensions = styled(Text)`
  font-size: 13px;
  color: ${COLORS.text};
`;

export const Empty = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textFaint};
`;

export const WarnText = styled(Text)`
  font-size: 12px;
  color: ${COLORS.warning};
`;

export const ErrorText = styled(Text)`
  font-size: 12px;
  color: ${COLORS.danger};
`;

export const Actions = styled.div`
  display: flex;
  gap: ${SPACE[8]};
  flex-wrap: wrap;
`;

/** The share card as Facebook and X draw a large-image link: the image at 1.91:1, then host, title, description. */
export const Card = styled.figure`
  display: flex;
  flex-direction: column;
  margin: 0;
  max-width: 520px;
  border-radius: 12px;
  border: 1px solid ${COLORS.panelBorder};
  background: ${COLORS.surfaceInset};
  overflow: hidden;
`;

export const CardLabel = styled(Text)`
  padding: ${SPACE[12]} ${SPACE[16]} ${SPACE[8]};
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${COLORS.textFaint};
`;

export const CardImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1.91 / 1;
  background: ${COLORS.surfaceSoft};
  border-top: 1px solid ${COLORS.panelBorder};
  border-bottom: 1px solid ${COLORS.panelBorder};

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const CardText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[4]};
  padding: ${SPACE[12]} ${SPACE[16]};
  min-width: 0;
`;

export const CardHost = styled(Text)`
  font-size: 12px;
  text-transform: uppercase;
  color: ${COLORS.textMuted};
  overflow-wrap: anywhere;
`;

export const CardTitle = styled(Text)`
  font-size: 15px;
  font-weight: 600;
  color: ${COLORS.text};
  overflow-wrap: anywhere;
`;

export const CardDescription = styled(Text)`
  font-size: 13px;
  line-height: 1.4;
  color: ${COLORS.textMuted};
  overflow-wrap: anywhere;
`;
